import styles from "./Tooltip.module.scss";

export const Tooltip = ({ text }) => {
  return <div className={styles.tooltip_container}>{text}</div>;
};
